<div class="line-list">  
  @for (line of orderShipment().lines; track line.lineNumber) {
    <div class="line-container">    
      <div class="line-title">
        <strong>
          Line #{{ line.lineNumber }}
          @if (line.drmType) {
            <span>({{ line.drmType}})</span>
          }
        </strong>
        - <button class="link" (click)="linkToPubAdmin(line.productNumber)">{{ line.title }}</button>

        <insight-order-line-languages
          class="line-languages"
          [audioLanguages]="line.audioLanguages"
          [subtitleLanguages]="line.subtitleLanguages">
        </insight-order-line-languages>
      </div>

      <div class="chip-set">
        @for (statusEntry of line.lineStatuses; track statusEntry.id) {
          @if (okToShowStepInTimeline(statusEntry)) {
            <span class="{{ calculateStepStyle(statusEntry) }}" >
              <span class="step-title"> {{ lineStatusDisplay(statusEntry.id)  }}
                <!-- show processing time on a step as long as it has started. Showing it on completed steps helps with troubleshooting-->
                @if (statusEntry.startTime !== null) {
                  for {{ calculateProcessingTime(statusEntry.startTime, statusEntry.endTime)}}
                }
              </span>
              <span class="step-progress"> {{ calculateDisplayStatus(statusEntry)  }}</span>
            </span>
          }
        }
        <!-- Cinelink and Streaming orders we have a record of the upload date -->
        @if (orderShipment().orderType != orderTypeEnum.Adebs) {
          <span class="{{ calculateUploadStatusStyle(line.uploadedContentOn, orderShipment().status) }}">
            <span class="step-title"> Uploading <mat-icon style="opacity: 0.5" title="AsperaUploadedDate field status set for Streaming orders and DeliveryDate set for Cinelink orders">info</mat-icon> </span>
            <!-- Not all content needs to be uploaded if it already exists on the server
            If there is no upload date, check to see if the order is complete. If it is, I guess that means we didn't need to upload
            any new content to the server. If the order is not complete...that means we still need to potentially upload something -->
            <span class="step-progress"> {{ line.uploadedContentOn ?
              'Completed ' + (line.uploadedContentOn | date:'M/d/yy @ h:mm a') :
            displayTextForNullUploadedContent(orderShipment().status)  }}</span>
          </span>
        }
      </div>
    </div>
  }
</div>
